<template>
  <el-form class="search-form" :inline="true" :model="filters" size="small">
    <el-row>
      <el-form-item label="发布时间：">
        <el-date-picker
          class="date-picker"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          v-model="filters.publishTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          unlink-panels
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item label="视频名称：">
        <el-input
          class="filter-input"
          prefix-icon="el-icon-search"
          v-model="filters.videoName"
          placeholder="请输入视频名称关键字"
        ></el-input>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.onlineStatus"
          placeholder="视频状态"
        >
          <el-option
            v-for="(item, i) in onlineData"
            :key="i"
            :label="item.paramValue"
            :value="item.paramKey"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-show="!showMore">
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="展开"
          iconName="el-icon-arrow-down"
          @click="showMore = true"
          class="czButn"
        ></butn>
      </el-form-item>
    </el-row>
    <el-row v-show="showMore">
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.categoryId"
          placeholder="视频分类"
        >
          <el-option
            v-for="item in categoryData"
            :key="item.uuid"
            :label="item.categoryName"
            :value="item.uuid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="select_btn">
        <el-select
          class="select_btn_style"
          v-model="filters.publisherId"
          placeholder="发布主体："
        >
          <el-option
            v-for="item in publisherData"
            :key="item.uuid"
            :label="item.publisherName"
            :value="item.uuid"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <butn btntype="primary" title="查询" @click="initData"></butn>
        <butn title="重置" @click="resetData" class="czButn"></butn>
        <butn
          title="收起"
          iconName="el-icon-arrow-up"
          @click="showMore = false"
          class="czButn"
        ></butn>
      </el-form-item>
    </el-row>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
import { categoryList } from "@/api/shortCategory";
import { publisherList } from "@/api/shortVideoPublisher";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      options: [],
      categoryData: [],
      publisherData: [],
      onlineData: [],
      showMore: false,
    };
  },
  created() {
    // 获取视频分类数据
    categoryList().then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        uuid: "",
        categoryName: "全部",
      });
      this.categoryData = res.data;
    });
    // 获取视频发布主体
    publisherList().then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        uuid: "",
        publisherName: "全部",
      });
      this.publisherData = res.data;
    });
    //获取上下线状态
    getDataMap("ONLINE_STATUS").then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        paramValue: "全部",
      });
      this.onlineData = res.data;
    });
  },
  computed: {
    dropWidth() {
      return this.showMore ? 18 : 10;
    },
  },
  methods: {
    initData() {
      let params = Object.assign({}, this.filters);
      delete params.publishTime;
      if (this.filters.publishTime) {
        params["startDate"] = this.filters.publishTime[0];
        params["endDate"] = this.filters.publishTime[1];
      }
      this.$emit("search", { ...params, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #d7dbe0;
$border-radius: 2px;
.search-form {
  text-align: left;
  & /deep/ .none-margin-right {
    margin-right: 0;
  }
  & /deep/ .date-picker {
    width: 240px;
  }
}
</style>
